import { render, staticRenderFns } from "./KusVatAccountsSelector.vue?vue&type=template&id=ed0e3c52"
import script from "./KusVatAccountsSelector.vue?vue&type=script&lang=js"
export * from "./KusVatAccountsSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports